import { Component, AfterViewInit, EventEmitter, OnInit, Output, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, Subscriber } from 'rxjs';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { ModalpopService } from '../modalpop.service';
import { element } from 'protractor';
import { HttpErrorResponse } from '@angular/common/http';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.scss']
})
export class PaymentHistoryComponent implements OnInit {
  payHistory: FormGroup;
  payHistoryData: any;
  SnNo: any;
  constructor(private fb: FormBuilder,
    public umsService: UmsService,
    public dialogRef1: MatDialogRef<PaymentHistoryComponent>,
    public dialog: MatDialog, private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,) { }
  tempCo
  StudentPersonalId
  Currency
  // convertUTCToIST(dateString: string): string {
  //   const utcDate = new Date(dateString); // Convert string to Date object
  //   const istDate = new Date(utcDate.getTime() - (330 * 60 * 1000)); // IST is UTC + 5:30
  //   return this.datePipe.transform(istDate, 'dd/MM/yyyy h:mm:ss a', 'Asia/Kolkata') || '';
  // }
  ngOnInit(): void {
    // this.Currency = sessionStorage.getItem('Currency')
    this.tempCo = sessionStorage.getItem('TemplateCode');
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.getSecretData()

  }

  getSecretData() {
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {

      this.SnNo = res.projectPharam['SnNo']
      this.getHistory(res.projectPharam['SnNo']);
    })
  }

  getHistory(SnNo) {
    this.spinner.show();
    let payload = {};
    payload['FeeTemplateCode'] = this.tempCo;
    payload['StuId'] = this.StudentPersonalId;
    payload['FeeHistory'] = 1;
    payload['SnNo'] = SnNo
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      this.spinner.hide();
      this.payHistoryData = res.data;
      if (res.data[0].FeeType == "EF") {
        this.Currency = sessionStorage.getItem('ExamCurrency')
      }
      else {
        this.Currency = sessionStorage.getItem('Currency')
      }

    })

  }

  close() {
    this.dialogRef1.close();
  }


  convertUTCToIST(dateString: string): string {
    const utcDate = new Date(dateString); // Convert string to Date object
    // Directly use the date pipe with 'Asia/Kolkata' time zone
    return this.datePipe.transform(utcDate, 'dd/MM/yyyy h:mm:ss a', 'Asia/Kolkata') || '';
  }

}
